import React, { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import authBg from "../../assets/images/big/auth-bg.jpg";
import $ from "jquery";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux"; // Import useDispatch
import { resetPassword } from "../../store/slices/userSlice"; // Import your resetPassword thunk action
import logo from "../../assets/images/logo.png";
import CryptoJS from "crypto-js";
import { unwrapResult } from "@reduxjs/toolkit"; // Import unwrapResult

const ResetPassword = () => {
  const { encryptedId: paramToken } = useParams();
  const location = useLocation();
  const dispatch = useDispatch(); // Initialize useDispatch

  const [token, setToken] = useState(paramToken || "");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Fade out the preloader
  useEffect(() => {
    $(".preloader").fadeOut();
  }, []);

  // If the token is passed via query string (?token=...), get it
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryToken = queryParams.get("token");
    if (queryToken) {
      setToken(queryToken);
    }
  }, [location.search]);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (newPassword.length < 8) {
      Swal.fire("Error", "New password must be at least 8 characters long!", "error");
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire("Error", "Passwords do not match!", "error");
      return;
    }

    try {
      const encryptedPassword = CryptoJS.SHA256(newPassword).toString();

      const payload = {
        token: token,
        password: encryptedPassword,
      };

      // Dispatch the resetPassword thunk and unwrap its result
      const actionResult = await(resetPassword(payload));
      const response = (actionResult); // This will throw an error if the thunk was rejected

      // If unwrapResult did not throw, it means the request was successful
      if (response?.status === 200) {
        Swal.fire({
          title: "Success!",
          text: "Your password has been reset successfully. Please log in with your new password.",
          icon: "success",
          confirmButtonText: "Go to Login",
          allowOutsideClick: false,
        }).then(() => {
          // Optionally redirect to login page after success
          window.location.href = "/"; // Or navigate('/') if using react-router-dom v6's navigate
        });
      } else {
        // This block might be hit if the backend returns a non-200 status but doesn't cause the thunk to reject
        Swal.fire("Error", response?.message || "Failed to reset password. Please try again.", "error");
      }
    } catch (error) {
      // Catch network errors, errors from the thunk's rejectWithValue, or other unexpected errors
      console.error("Error resetting password:", error);

      let errorMessage = "Something went wrong! Please try again.";

      // Attempt to get a more specific error message from the backend response
      if (error && error.message) {
        errorMessage = error.message; // Error message from rejectWithValue
      } else if (error && error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message; // Common for Axios errors
      }

      Swal.fire("Error", errorMessage, "error");
    }
  };

  return (
    <div className="main-wrapper">
      <div className="preloader">
        <div className="lds-ripple">
          <div className="lds-pos"></div>
          <div className="lds-pos"></div>
        </div>
      </div>
      <div
        className="auth-wrapper d-flex no-block justify-content-center align-items-center position-relative"
        style={{ background: `url(${authBg}) no-repeat center center` }}
      >
        <div className="auth-box row d-flex no-block justify-content-center align-items-center">
          <div className="col-lg-5 col-md-7 bg-white">
            <div className="p-3">
              <div className="text-center">
                <img src={logo} width="100%" alt="Logo" />
              </div>
              <h2 className="mt-3 text-center">Reset Password</h2>
              <form className="mt-4" onSubmit={handleResetPassword}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="newPassword">
                        New Password (min 8 characters)
                      </label>
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        id="newPassword"
                        name="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        minLength="8" // Add HTML5 validation
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="confirmPassword">
                        Re-enter Password
                      </label>
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        id="confirmPassword"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        minLength="8" // Add HTML5 validation
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 mb-3">
                    <input
                      type="checkbox"
                      id="showPassword"
                      checked={showPassword}
                      onChange={() => setShowPassword(!showPassword)}
                    />{" "}
                    <label htmlFor="showPassword">Show Password</label>
                  </div>
                  <div className="col-lg-12 text-center">
                    <button type="submit" className="btn w-100 btn-dark">
                      Reset Password
                    </button>
                  </div>
                  <div className="col-lg-12 text-center mt-5">
                    <Link to="/">Back to Login</Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;